import { Controller } from "@hotwired/stimulus"
import $ from "jquery";

export default class extends Controller {
    // workaround to type readonly element
    // this will return the element that was detected as controller

    get el() {
        return this.element;
    }

    connect() {
        const dropdown = $(this.el);
        const dropdownContent = $(dropdown).find(".dropdown__content");
        $(dropdown).on("mouseleave", function(event) {
            $(dropdownContent).removeClass("dropdown__content--visible");
        });
    }

    toggleDropdown(event) {
        event.preventDefault();
        const dropdown = $(this.el);
        const dropdownContent = $(dropdown).find(".dropdown__content");
        $(dropdownContent).toggleClass("dropdown__content--visible");
    }

    selectItem(event) {
        event.preventDefault();

        $(this.el).find(".form-field").val(event.target.dataset.value);
        $(this.el).closest("form").submit();
    }
}

